import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import FamilyHomeListCard from './FamilyHomeListCard';

const FamilyHomeListCards = observer((props) => {
  const store = props.SeniorStore;
  const createUniqueList = props.createUniqueList;

  return (
    <Grid container direction="row">
      {store.allseniors &&
        store.allseniors.length > 0 &&
        createUniqueList(store.allseniors).map((senior) => {
          return (
            <Grid item xs={12} sm={6} md={4} key={senior.id}>
              <FamilyHomeListCard
                senior={senior}
                store={store}
                key={senior.id}
                renderWorkbookModuleCells={props.renderWorkbookModuleCells}
                renderWorkbookModuleGrid={props.renderWorkbookModuleGrid}
              />
            </Grid>
          );
        })}
    </Grid>
  );
});

export default FamilyHomeListCards;
